import React from "react";
import { getIconPath } from "../../../utils/util";

const Icon = ({ name, size = 20, className }) => {
  return (
      <img className={className} src={getIconPath(name)} alt={name} width={size} height={size} />
  );
};

export default Icon;
